import React, { useState } from "react";
import client6 from "../assets/images/clients/6.png";
import client7 from "../assets/images/clients/7.png";
import FooterTwo from "../components/footers/FooterTwo";
import ClientLogo from "../features/common/ClientLogo";
import RightPlan from "../features/common/RightPlan";
import Counter from "../features/landingpage-two/Counter";
import Coustomer from "../features/common/Coustomer";
import Features from "../features/landingpage-two/Features";
import FunfactVideo from "../features/landingpage-two/FunfactVideo";
import { Link } from "react-router-dom";

const LandingPageTwo = () => {
  const [dataBlock] = useState({
    title: "Smart and effective solutions for businesses.",
    subTitle: "Make a website you’ll be proud of",
    since: "Since 1911",
  });
  return (
    <>
      <section className="md:pt-[160px] md:pb-[170px] pt-[100px] pb-[120px] relative bg-cover bg-center bg-themedark">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat w-full h-full bg-[url('../images/home_sec_layer-2.png')]"></div>
        <div className="container relative">
          <div className="grid grid-cols-1 lg:grid-cols-5 items-center gap-[30px]">
            <div className="lg:col-span-3">
              <p className="py-2.5 px-5 bg-white/[0.03] italic inline-block rounded-lg text-custom mb-4 md:mb-0">
                {dataBlock.since}
              </p>
              <h1 className="mt-4 md:text-[56px] text-[34px] leading-[1.2] text-white">
                {dataBlock.title}
              </h1>
              <p className="mt-6 text-lg text-white/40">{dataBlock.subTitle}</p>
              <div className="mt-12">
                <Link to="#" className="btn-custom rounded-none">
                  See How It Works
                </Link>
              </div>
              <div className="bg-white/[8%] w-full h-px block my-10 md:my-[50px]"></div>
              <div className="sm:space-y-0 space-y-4">
                <div className="items-center sm:inline-block block">
                  <span className="text-muted capitalize">Trusted partners:</span>
                </div>
                <div className="inline-block">
                  <img
                    src={client6}
                    alt="client6"
                    className="h-[26px] my-2 mx-3 opacity-70 inline-block"
                  />
                  <img
                    src={client7}
                    alt="client7"
                    className="h-[26px] my-2 mx-3 opacity-70 inline-block"
                  />
                </div>
              </div>
            </div>
            <div className="lg:col-span-2">
              <div className="bg-white py-10 px-5 md:py-[60px] md:px-[30px] rounded">
                <h2 className="text-center font-bold text-[32px]">
                  Get 30 days FREE Trial
                </h2>
                <p className="text-muted text-center mt-4">
                  Landik offers functional contact forms that are fully
                  customizable. Try it yourself!
                </p>
                <form action="" className="mt-12 space-y-4">
                  <div>
                    <input
                      type="text"
                      className="form-input !border-none h-[52px]"
                      placeholder="Your Name"
                      required=""
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      className="form-input !border-none h-[52px]"
                      placeholder="Email Id"
                      required=""
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      className="form-input !border-none h-[52px]"
                      placeholder="Mobile Number"
                      required=""
                    />
                  </div>
                  <button
                    className="btn-custom rounded-none !mt-8 w-full"
                    type="submit"
                  >
                    Start Trial
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Features />
      <FunfactVideo/>
      <RightPlan/>
      <Counter/>
      <Coustomer/>
      <ClientLogo/>
      <FooterTwo/>
    </>
  );
};

export default LandingPageTwo;
